__turbopack_context__.v({
  "articleContainer": "ShortcutsTerrace-module-scss-module__DBgIrW__articleContainer",
  "articleContainerThemeColor": "ShortcutsTerrace-module-scss-module__DBgIrW__articleContainerThemeColor",
  "blocksBackgroundColor": "ShortcutsTerrace-module-scss-module__DBgIrW__blocksBackgroundColor",
  "blocksFontColor": "ShortcutsTerrace-module-scss-module__DBgIrW__blocksFontColor",
  "container": "ShortcutsTerrace-module-scss-module__DBgIrW__container",
  "containerDragging": "ShortcutsTerrace-module-scss-module__DBgIrW__containerDragging",
  "editDropDown": "ShortcutsTerrace-module-scss-module__DBgIrW__editDropDown",
  "editDropDownThemeColor": "ShortcutsTerrace-module-scss-module__DBgIrW__editDropDownThemeColor",
  "editingButtons": "ShortcutsTerrace-module-scss-module__DBgIrW__editingButtons",
  "editorButton": "ShortcutsTerrace-module-scss-module__DBgIrW__editorButton",
  "icon": "ShortcutsTerrace-module-scss-module__DBgIrW__icon",
  "iconEditing": "ShortcutsTerrace-module-scss-module__DBgIrW__iconEditing",
  "iconReorder": "ShortcutsTerrace-module-scss-module__DBgIrW__iconReorder",
  "reorder": "ShortcutsTerrace-module-scss-module__DBgIrW__reorder",
  "reorderBanner": "ShortcutsTerrace-module-scss-module__DBgIrW__reorderBanner",
  "secondaryNavBackgroundColor": "ShortcutsTerrace-module-scss-module__DBgIrW__secondaryNavBackgroundColor",
  "themeBackgroundColor": "ShortcutsTerrace-module-scss-module__DBgIrW__themeBackgroundColor",
  "themeFontColor": "ShortcutsTerrace-module-scss-module__DBgIrW__themeFontColor",
  "themeFontFamily": "ShortcutsTerrace-module-scss-module__DBgIrW__themeFontFamily",
  "title": "ShortcutsTerrace-module-scss-module__DBgIrW__title",
  "titleThemeColor": "ShortcutsTerrace-module-scss-module__DBgIrW__titleThemeColor",
});
